export default __webpack_public_path__ + "b843c9a433e20cf17f783bb6d5891799.png";